import * as React from "react";
import { colorAttentionGreen50, colorAttentionRed10, colorAttentionRed50, colorFunctionalGray10, colorFunctionalGray30, } from "@rhumbix/rmbx_design_system_design_tokens";
/** Const */
const BASE_SVG_WIDTH = 72;
const BAR_OUTER_WIDTH = 72;
const BASE_SVG_HEIGHT = 15;
const BAR_MAXIMUM = 100;
const PADDING = 1;
const ProgressBar = ({ percentComplete = 0 }) => {
    let innerBarValue = percentComplete, outerBarFillColor = colorFunctionalGray10, innerBarFillColor = colorAttentionGreen50, strokeColor = colorFunctionalGray30;
    if (percentComplete > BAR_MAXIMUM) {
        innerBarValue -= BAR_MAXIMUM;
        outerBarFillColor = colorAttentionRed10;
        innerBarFillColor = colorAttentionRed50;
        strokeColor = colorAttentionRed50;
    }
    let innerBarWidth = innerBarValue * 0.01 * BAR_OUTER_WIDTH - 2 * PADDING;
    if (innerBarWidth < 0)
        innerBarWidth = 0;
    return (React.createElement("svg", { width: BASE_SVG_WIDTH, height: BASE_SVG_HEIGHT, fill: "#000000" },
        React.createElement("rect", { width: BAR_OUTER_WIDTH, height: BASE_SVG_HEIGHT, fill: outerBarFillColor, rx: "0", ry: "0", stroke: strokeColor }),
        React.createElement("rect", { width: innerBarWidth, height: BASE_SVG_HEIGHT - 2 * PADDING, fill: innerBarFillColor, rx: "0", ry: "0", x: PADDING, y: PADDING })));
};
export default ProgressBar;
